package learning.containers


import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.api.clients.ContentApiClient
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.ContentType
import community.components.TopicCommentEdit
import learning.components.TcmFaqCommentEdit
import react.*
import react.dom.div
import setTitle

external interface TcmFaqCommentEditPageProps : RProps {
    var topicId:String
    var commentId:String
}

data class TcmFaqCommentEditPageContextData(
    var getTopic:(type: ContentType, id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getCommentById:(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Comment>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit,
    var save:(comment:com.jingfangpai.common.orm.mapping.Comment, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<Comment>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val TcmFaqCommentEditPageContext = createContext(TcmFaqCommentEditPageContextData(ContentApiClient::getContent,CommentApiClient::getCommentById,CommentApiClient::save))

val TcmFaqCommentEditPageProvider = functionalComponent<TcmFaqCommentEditPageProps> { props ->

    setTitle("回答编辑")

    useEffectOnce { }

    TcmFaqCommentEditPageContext.Provider(TcmFaqCommentEditPageContextData(ContentApiClient::getContent,CommentApiClient::getCommentById,CommentApiClient::save)) {
        div("TopicCommentEditPage-content") {
            child(TcmFaqCommentEdit) {
                attrs{
                    topicId = props.topicId
                    commentId = props.commentId
                }
            }
        }
    }
}
